import store from "@/store";
import router from "@/router";
import { General } from "@/utils/constants";
import { downloadWithURL } from "@/utils/fileUtility";
import { ISocketEvent } from "@/store/types/types";
import { PROCESS_DETAILS_TABS as PROCESS_DETAILS } from "@/utils/enumerate";
import { IUserNotification } from "@/store/types/user-types";

const inOpenProcess = "/app/novo-processo";

function processUpdateAction(data: any) {
  const actualPath = router.currentRoute.path;
  const inProcessDetail = `/app/processos/detalhamento/${data?.process_id}`;
  const isTabDispatch =
    store.getters.getCurrentTabProcessDetails.value ===
    PROCESS_DETAILS.ORDERS.value;
  if (
    actualPath.includes(inProcessDetail) &&
    isTabDispatch &&
    data.text.search(/assinatura|assinou/) >= 0
  )
    store.commit("setNewDispatchUpdate");
  store.commit("updateProcessActionsWebSocket", data);
}

function signatureUpdate(data: any) {
  const actualPath = router.currentRoute.path;
  actualPath.includes(inOpenProcess) &&
    store.dispatch("processAutoDraftRequest");
  store.dispatch("socketUpdateSignature", data);
}

function updateSignatureState(data: any) {
  const status = data?.error ? "error" : "done";
  store.dispatch("updateStateDocumentSignWebSocket", {
    ...data,
    status
  });
  store.commit("checkDoneSignatureDocuments");
  store.dispatch("certificateSignTrigger");
  store.dispatch("electronicSignTrigger");
}

function automaticProcessingStarting({ relected_type_id }: any) {
  const actualPath = router.currentRoute.path;
  const inProcessDetail = `/app/processos/detalhamento/${relected_type_id}`;

  if (relected_type_id === store.getters.getCurrentProcess.id) {
    const isProcessDetail = actualPath.includes(inProcessDetail);
    if (isProcessDetail)
      store.commit("setCurrentProcess", {
        ...store.getters.getCurrentProcess,
        automatic_processing_starting: true
      });
  } else if (
    actualPath.includes(inOpenProcess) &&
    relected_type_id === store.getters.getNewProcess.id
  )
    store.commit("setNewProcess", {
      ...store.getters.getNewProcess,
      automatic_processing_starting: true
    });
}

function automaticProcessing({ relected_type_id, type }: IUserNotification) {
  const actualPath = router.currentRoute.path;
  const isAutomaticProcess = RegExp(
    General.TEXTS.AUTOMATIC_PROCESSING,
    "gi"
  ).test(type);

  if (!isAutomaticProcess) return;

  const isProcessDetail = actualPath.includes(
    `/app/processos/detalhamento/${relected_type_id}`
  );

  if (type === General.TEXTS.AUTOMATIC_PROCESSING) {
    if (isProcessDetail) router.replace("/app/processos");
    else
      store.commit("setNewProcess", {
        ...store.getters.getNewProcess,
        automatic_processing_starting: false,
        id: null
      });
  } else if (type === General.TEXTS.AUTOMATIC_PROCESSING_CANCELLED) {
    if (isProcessDetail) {
      store.commit("setCurrentProcess", {
        ...store.getters.getCurrentProcess,
        automatic_processing_starting: false
      });
      store.commit("setClearDispatch");
      store.commit("dispatchGetDraft", relected_type_id);
    } else {
      store.commit("setNewProcess", {
        ...store.getters.getNewProcess,
        automatic_processing_starting: false
      });
      store.commit("setClearProcess");
      store.dispatch("processAutoDraftRequest");
    }
  }
}

function handleDashboardCapacityCommit(action: string, data: any) {
  const actionMap: Record<string, string> = {
    dashboard_capacity_info_count: "setDashboardInfoSocket",
    dashboard_capacity_subjects: "setDashboardSubjectSocket",
    dashboard_capacity_capacities: "setDashboardCapacitiesSocket",
    dashboard_capacity_due_date_info: "setDashboardDueDateSocket",
    dashboard_capacity_productivity: "setDashboardProductivitySocket",
    dashboard_capacity_process_analises: "setDashboardProcessAnalisesSocket",
    update_capacity_dashboard_info_date: "setDueDateListSocket"
  };

  const commitAction = actionMap[action];
  if (commitAction) {
    store.commit(commitAction, data);
  }
}

function handleDashboardCommit(action: string, data: any) {
  const actionMap: Record<string, string> = {
    update_dashboard_info_count: "setDashboardInfo",
    update_dashboard_subjects: "setDashboardSubject",
    update_dashboard_capacities: "setDashboardCapacities",
    update_dashboard_due_date_info: "setDashboardDueDate",
    update_dashboard_productivity: "setDashboardProductivity",
    update_dashboard_process_analises: "setDashboardProcessAnalises",
    update_dashboard_info_date: "setDueDateList"
  };

  const commitAction = actionMap[action];
  if (commitAction) {
    store.commit(commitAction, data);
  }
}

function handleOtherCommit(action: string, data: any): boolean {
  const actionMap: Record<string, string> = {
    notification: "socketNotification",
    update_tab: "setUpdateBySockets",
    alert: "showJoinMenssage"
  };

  const commitAction = actionMap[action];
  if (commitAction) {
    store.commit(commitAction, data);
  }
  return Boolean(commitAction);
}

function handleSocketAction(status = "") {
  const statusMap: Record<string, Function> = {
    Connected: () => store.commit("setConnect", true),
    Disconnected: () => {
      store.commit("setConnect", false);
      process.env.VUE_APP_ENVIRONMENT !== "e2e" &&
        store.dispatch("holidaysRequest");
    }
  };

  const socketAction = statusMap[status];
  if (socketAction) socketAction();
}

function handleOtherAction(action: string, data: any) {
  const actionMap: Record<string, Function> = {
    migration_status: () => store.dispatch("updateMigration", data),
    migration_report: () => downloadWithURL(data, "Relatorio_migracao", "pdf"),
    process_action: () => processUpdateAction(data),
    update_signature: () => signatureUpdate(data),
    sign_response: () => updateSignatureState(data),
    automatic_processing_starting: () => automaticProcessingStarting(data),
    automatic_processing: () => automaticProcessing(data),
    resume_file: () => store.commit("updateProcessDownloadState", data),
    subject_report: () =>
      store.dispatch("startDownload", { ...data, deleteTime: 3e5 })
  };

  const dispatchAction = actionMap[action];
  if (dispatchAction) dispatchAction();
}

function handleLocalAction(action: string, data: any) {
  const actionMap: Record<string, Function> = {
    update_local_file: () => store.dispatch("updateProcessObjectFile", data),
    update_list_attachments: () =>
      store.dispatch("updateListAttachmentsTrigger", data)
  };

  const dispatchAction = actionMap[action];
  if (dispatchAction) dispatchAction();
}

export const SocketHandlerEvents = (eventName: string, event: ISocketEvent) => {
  if (!eventName.startsWith("SOCKET_")) return;

  const target = eventName.toUpperCase();
  let message = event;

  if (
    typeof event.data === "string" &&
    !event.data.includes("This JWT is not valid")
  )
    message = JSON.parse(event.data);

  const { action, data, status, notSendAllSlaves } = message;

  if (!notSendAllSlaves) store.dispatch("sendAllSlaves", message);
  status && handleSocketAction(status);

  if (!action) {
    if (target === "SOCKET_BROADCAST") return;
    return store.commit(target, message);
  }

  if (action.includes("dashboard")) {
    if (store.getters.getViewSector !== "INDIVIDUAL")
      handleDashboardCapacityCommit(action, data);
    else handleDashboardCommit(action, data);
  } else {
    handleOtherCommit(action, data);
    handleOtherAction(action, data);
    handleLocalAction(action, data);
  }
};
